import React from "react";
import { createRoot } from "react-dom/client";
// import "./index.css";
import Prism from "prismjs";
import { loadRuntimeConfig } from "@content-buddy/shared/hooks/runtimeConfig";
import App from "./App";

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById("root"),
// );

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _unused = Prism.languages;

async function main(): Promise<void> {
  await loadRuntimeConfig();

  const container = document.getElementById("root");
  if (container) {
    const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  } else {
    // eslint-disable-next-line no-console
    console.log("Missing root element");
  }
}

void main();
